import { useTheme } from 'context/themeContext';
import './subTituloSeccion.scss';
import { CSSProperties } from 'react';

interface ISubTituloSeccion {
    text: string;
    uppercase?:boolean;
    className?:string;
    style?: CSSProperties;
}

export default function SubTituloSeccion( {text, uppercase, className, style}:ISubTituloSeccion) {
    const theme = useTheme();
    return <h4 className={`subtituloSeccion ${uppercase ? 'upper':''} ${className ? className:''}`} style={{...{color:theme.colors.primaryText}, ...style}} data-testid="busquedas-recientes">{text}</h4>;
}
